import { required, numeric, between } from 'vuelidate/lib/validators'
import { validateReferenceNumber } from '@/validators'

const ValidationsMixin = {
  provide () {
    // Dependency injection: provide/inject
    return { $v: this.$v }
  },
  data () {
    return {
      newOpportunity: {
        opportunityDetailsTab: {
          typeId: '',
          brandId: '',
          opportunityName: '',
          referenceNumber: '',
          departureDate: '',
          regionId: '',
          ownerId: ''
        },
        clientInformationTab: {
          typeId: '',
          accountName: '',
          email: '',
          phoneNumber: '',
          address: '',
          contactName: ''
        },
        quoteRequestTab: {
          supplierId: '',
          stageId: '',
          hotelStandard: '',
          focPlaces: '',
          budget: '',
          priceBreak: '',
          guests: '',
          commission: '',
          arrivalAirportPort: '',
          departureAirportPort: '',
          quoteDeadline: '',
          difficultDatesChecked: false,
          flourishesLocalTreats: false,
          gratuitiesForTdDriver: false,
          tdOfferOptionals: false,
          prebookingsRequired: false,
          repeatGuestGift: false,
          includingLocalGuides: false,
          birthdayAllowance: false,
          groupPhoto: false,
          additionalInformation: '',
          additionalFileId: ''
        },
        opportunitySelection: []
      }
    }
  },
  validations () {
    if (!this.hasDescription) {
      return {
        newOpportunity: {
          opportunityDetailsTab: {
            typeId: { required },
            brandId: {},
            opportunityName: {},
            referenceNumber: { validateReferenceNumber },
            departureDate: {},
            regionId: { required },
            ownerId: {},
            ownerName: {},
          },
          clientInformationTab: {
            typeId: {},
            accountName: {},
            email: {},
            phoneNumber: {},
            address: {},
            contactName: {}
          },
          quoteRequestTab: {
            supplierId: {},
            stageId: {},
            hotelStandard: {},
            focPlaces: {},
            budget: {},
            priceBreak: {},
            guests: { numeric, between: between(0, 99999) },
            commission: { numeric, between: between(0, 100) },
            arrivalAirportPort: {},
            departureAirportPort: {},
            quoteDeadline: {},
            difficultDatesChecked: {},
            flourishesLocalTreats: {},
            gratuitiesForTdDriver: {},
            tdOfferOptionals: {},
            prebookingsRequired: {},
            repeatGuestGift: {},
            includingLocalGuides: {},
            birthdayAllowance: {},
            groupPhoto: {},
            additionalInformation: {},
            additionalFileId: {}
          },
          opportunitySelection: {}
        }
      }
    } else {
      return {
        newOpportunity: {
          opportunityDetailsTab: {
            typeId: { required },
            brandId: { required },
            opportunityName: {},
            referenceNumber: { validateReferenceNumber },
            departureDate: {},
            regionId: { required },
            ownerId: {}
          },
          clientInformationTab: {
            typeId: {},
            accountName: {},
            email: {},
            phoneNumber: {},
            address: {},
            contactName: {}
          },
          quoteRequestTab: {
            supplierId: {},
            stageId: {},
            hotelStandard: {},
            focPlaces: {},
            budget: {},
            priceBreak: {},
            guests: { numeric, between: between(0, 99999) },
            commission: { numeric, between: between(0, 100) },
            arrivalAirportPort: {},
            departureAirportPort: {},
            quoteDeadline: {},
            difficultDatesChecked: {},
            flourishesLocalTreats: {},
            gratuitiesForTdDriver: {},
            tdOfferOptionals: {},
            prebookingsRequired: {},
            repeatGuestGift: {},
            includingLocalGuides: {},
            birthdayAllowance: {},
            groupPhoto: {},
            additionalInformation: {},
            additionalFileId: {}
          },
          opportunitySelection: {}
        }
      }
    }
  }
}

export default ValidationsMixin
